import * as React from 'react';
import Typography from '@material-ui/core/Typography';

function RichTextBlock({ text, ...props }) {
    function parseToArray(text) {
        const rxBold = /\*\*((?![(\*\*)])[\w\W])*\*\*/;
        const rxItalic = /\*((?![(\*)])[\w\W])*\*/;
        const rxHref = /\[(((?![(\[\]\(\))])[\w\W])*)\]\((((?![(\[\]\(\))])[\w\W])*)\)/;

        let regExpArray = { rx_bold: rxBold, rx_href: rxHref, rx_italic: rxItalic };
        let resultArray = [];

        matchRegExp(regExpArray, text, resultArray);

        return resultArray;
    }

    function matchRegExp(rxArray, matchedObject, resultArray) {
        if (!matchedObject || matchedObject === '') {
return true;
}
        if (rxArray.rx_href.test(matchedObject)) {
            let result = matchedObject.match(rxArray.rx_href);
            let newArr = [];

            matchRegExp(rxArray, matchedObject.substring(0, result.index), resultArray);
            matchRegExp(rxArray, result[1], newArr);

            resultArray.push({ type: 'link', value: newArr, href: result[3] });

            matchRegExp(rxArray, matchedObject.substring(result.index + result[0].length), resultArray);
            return true;
        }
        if (rxArray.rx_bold.test(matchedObject)) {
            let result = matchedObject.match(rxArray.rx_bold);

            matchRegExp(rxArray, matchedObject.substring(0, result.index), resultArray);
            resultArray.push({ type: 'bold', value: result[0].substring(2, result[0].length - 2) });

            matchRegExp(rxArray, matchedObject.substring(result.index + result[0].length), resultArray);
            return true;
        }
        if (rxArray.rx_italic.test(matchedObject)) {
            let result = matchedObject.match(rxArray.rx_italic);

            matchRegExp(rxArray, matchedObject.substring(0, result.index), resultArray);
            resultArray.push({ type: 'italic', value: result[0].substring(2, result[0].length - 2) });

            matchRegExp(rxArray, matchedObject.substring(result.index + result[0].length), resultArray);
            return true;
        }
        resultArray.push({ type: 'text', value: matchedObject });
        return true;
    }

    function arrayToHTMLCoding(text) {
        let parsedArray = parseToArray(text);
        let resultArray = [];
        for (let i = 0; i < parsedArray.length; i++) {
            if (parsedArray[i].type === 'link') {
                let buffer = [];
                // buffer.push(<a href= {parsedArray[i].href} >);
                for (let j = 0; j < parsedArray[i].value.length; j++) {
                    if (parsedArray[i].value[j].type === 'bold') {
                        buffer.push(<strong key={j}>{parsedArray[i][j].value}</strong>);
                    } else if (parsedArray[i].value[j].type === 'italic') {
                        buffer.push(<i key={j}>{parsedArray[i][j].value}</i>);
                    } else if (parsedArray[i].value[j].type === 'text') {
                        buffer.push(<span key={j}>{parsedArray[i].value[j].value}</span>);
                    }
                }
                resultArray.push(
                    <a
                        className={props.classes.link || ''}
                        key={i}
                        href={parsedArray[i].href}
                    >
                        {buffer}
                    </a>
                );
            } else if (parsedArray[i].type === 'bold') {
                resultArray.push(<strong key={i}> {parsedArray[i].value} </strong>);
            } else if (parsedArray[i].type === 'italic') {
                resultArray.push(<i key={i}> {parsedArray[i].value} </i>);
            } else if (parsedArray[i].type === 'text') {
                resultArray.push(<span key={i}>{parsedArray[i].value}</span>);
            }
        }
        return resultArray;
    }

    function parseTextBlock(textBlock) {
        const rxListIdentifier = /(^-)/;
        // const rx_emptyLine = /(^\n)/;

        if (!textBlock) {
            return true;
        }

        let splitedTextArray = textBlock.split('\n');
        let parsedTextArray = [];
        let listArray = [];

        for (let i = 0; i < splitedTextArray.length; i++) {
            if (rxListIdentifier.test(splitedTextArray[i])) {
                listArray.push(
                    <li key={i}>
                        <Typography
                            component="p"
                            className={props.className}
                            key={i + '1'}
                        >
                            {arrayToHTMLCoding(splitedTextArray[i].substring(1))}
                        </Typography>
                    </li>
                );
                if ((i + 1) === splitedTextArray.length) {
                    parsedTextArray.push(
                        <ul key={i + '2'}> {listArray.slice(0)}</ul>
                    );
                }
            } else if ((i - 1) >= 0 && rxListIdentifier.test(splitedTextArray[i - 1])
                && !rxListIdentifier.test(splitedTextArray[i])) {
                parsedTextArray.push(
                    <ul key={i + '2'}> {listArray.slice(0)}</ul>
                );
                listArray = [];
                parsedTextArray.push(
                    <Typography
                        className={props.className}
                        key={i + '3'}
                        component="p"
                        paragraph={true}

                    >
                        {arrayToHTMLCoding(splitedTextArray[i])}
                    </Typography>
                );
            } else if (splitedTextArray[i]) {
                parsedTextArray.push(
                    <Typography
                        className={props.className}
                        key={i + '5'}
                        component="p"
                        paragraph={true}

                    >
                        {arrayToHTMLCoding(splitedTextArray[i])}
                    </Typography>
                );
            }
        }

        return parsedTextArray;
    }

    return parseTextBlock(text);
}

export default RichTextBlock;
